export default function usePermissionsData() {
  const { $rentals, $captureError } = useNuxtApp()
  const permissions = usePermissions()

  /**
   * Fetches permissions data from the API.
   */
  function getPermissions() {
    return $rentals('/api/account/me/permissions')
  }

  /**
   * Gets and sets permission data.
   */
  async function getAndSetPermissions() {
    try {
      permissions.value = await getPermissions()
    }
    catch (error) {
      $captureError(error)
    }
  }

  /**
   * Resets permission data.
   */
  function resetPermissions() {
    permissions.value = []
  }

  return {
    permissions,

    getPermissions,
    getAndSetPermissions,
    resetPermissions,
  }
}
